import { NewGroupStepper } from '@/pages/workgroup/form/Stepper';
import { Container, ChildPage } from '@/pages/workgroup/form/StyledComponent';
import SupportDrawer from '@/pages/home/support/SupportDrawer';
import { supportOpenAtom } from '@/pages/home/support/atom';
import { useAtom } from 'jotai';
import { Outlet } from 'react-router-dom';

export default function GroupLayout() {
  const [isSupportOpen, setIsSupportOpen] = useAtom(supportOpenAtom);

  return (
    <>
      <Container>
        <NewGroupStepper />
        <ChildPage>
          <Outlet />
        </ChildPage>
      </Container>
      <SupportDrawer isShow={isSupportOpen} onClose={() => setIsSupportOpen(false)} />
    </>
  );
}
